/**
 * @file Builds Uppy file meta with JSON XHR payload for non-ZIP document uploads.
 */

import { isZipUploadFile } from './create-s3-multipart-plugin';

/**
 * Builds Uppy file meta envelope plus JSON payload field for XHR single-file uploads.
 * ZIP files omit the JSON payload (multipart transport handles them).
 * @param input.uploadKind - Registered kind string.
 * @param input.resourceKey - Session resource key.
 * @param input.scopeMeta - Kind-specific meta spread onto file meta (e.g. `transitionId`).
 * @param input.xhrMetaField - Form field name for JSON payload (must be in `xhrAllowedMetaFields`).
 * @param input.buildJsonPayload - Builds API request body for non-ZIP files.
 */
export const buildJsonPayloadFileMeta = (input: {
  uploadKind: string;
  resourceKey: string;
  scopeMeta: Record<string, unknown>;
  file: File;
  xhrMetaField: string;
  buildJsonPayload: (file: File) => unknown;
}): Record<string, unknown> => ({
  uploadKind: input.uploadKind,
  resourceKey: input.resourceKey,
  ...input.scopeMeta,
  [input.xhrMetaField]: isZipUploadFile(input.file)
    ? undefined
    : JSON.stringify(input.buildJsonPayload(input.file)),
});
